module.exports = __webpack_public_path__ + "media/assets/images/smart_working/footer-8959b6b89762f319a8ce7f602fd4c2e8.png";